import { render, staticRenderFns } from "./AvatarRounded.vue?vue&type=template&id=4787a048"
import script from "./AvatarRounded.vue?vue&type=script&lang=js"
export * from "./AvatarRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports